import { t } from 'i18next';
import React from 'react';
import { Helmet } from 'react-helmet';

export default function Terms() {
  return (
    <>
      <Helmet>
        <title>{t('termsAndConditions')}</title>
      </Helmet>
      <div className="max-w-2xl mx-auto mt-5 top-0 px-6 lg:px-0">
        <div className="bg-white rounded-3xl p-5 md:p-10 shadow-md shadow-black/5">
          <div className="max-w-sm mx-auto">
            <h2 className="font-semibold text-xl text-center mb-5">
              {t('termsAndConditions')}
            </h2>
          </div>
          <article className="prose prose-sm prose-h3:text-gray-600 ">
            <h4>Consultation and Workshop Services - Terms and Conditions</h4>
            <p>
              These terms and conditions outline the agreement between Emstell
              Kuwait Team (referred to as "we," "us," or "our") and the client
              (referred to as "you" or "client") in relation to our consultation
              services for software solutions, websites, and mobile apps, as
              well as our workshop services.
            </p>
            <h4>1. Language and Communication:</h4>
            <ul>
              <li>
                All consultations, reports, and workshop sessions will be
                conducted in English. You are required to have a reasonable
                comfort level with the English language for effective
                communication.
              </li>
            </ul>
            <h4>2. Basic Computer Skills:</h4>
            <ul>
              <li>
                You should possess basic computer skills, including web browsing
                and using office tools, to fully engage in our consultation and
                workshop services.
              </li>
            </ul>
            <h4>3. Clear Business Idea:</h4>
            <ul>
              <li>
                Prior to engaging in our consultation services, you should have
                a clear and well-defined business idea that outlines your
                requirements for end users. For workshop attendees, a clear
                understanding of your business idea is essential to benefit
                fully from the workshop content.
              </li>
            </ul>
            <h4>4. Legal and Business Requirements:</h4>
            <ul>
              <li>
                You are responsible for ensuring that your business idea,
                software solution, website, or mobile app complies with all
                legal and business requirements as per the applicable laws of
                your jurisdiction. We are not liable for any legal or regulatory
                issues arising from your project.
              </li>
            </ul>
            <h4>5. Consultation Report:</h4>
            <ul>
              <li>
                For Project-Specific Consultations, the consultation report
                provided is based on the information and details shared during
                our discussions. It offers recommendations and insights specific
                to your project needs.
              </li>
            </ul>
            <h4>6. Staff Planning and Outsourcing:</h4>
            <ul>
              <li>
                Our guidance on staff planning and outsourcing is based on
                industry expertise and best practices. However, the final
                decisions on staffing and outsourcing are solely yours, and we
                do not assume any responsibility for the outcomes.
              </li>
            </ul>
            <h4>7. Risk Mitigation and Technical Considerations:</h4>
            <ul>
              <li>
                Our guidelines for risk mitigation and technical considerations
                are provided to help you make informed decisions. It is your
                responsibility to assess and implement these recommendations.
              </li>
            </ul>
            <h4>8. Direct Meetings:</h4>
            <ul>
              <li>
                All direct meetings, whether in-person or via Zoom, are
                scheduled in advance. Please ensure you are available at the
                agreed-upon time. Missed appointments may result in rescheduling
                and delays.
              </li>
            </ul>
            <h4>9. Workshop Participation:</h4>
            <ul>
              <li>
                Workshop attendees should arrive on time for the scheduled
                workshop session. Participation and engagement are crucial for
                maximizing the benefits of the workshop content.
              </li>
            </ul>
            <h4>10. Workshop Materials:</h4>
            <ul>
              <li>
                Workshop materials, including presentations, handouts, and
                activities, are provided for educational purposes. These
                materials are protected by copyright and should not be
                reproduced or distributed without our consent.
              </li>
            </ul>
            <h4>11. Confidentiality:</h4>
            <ul>
              <li>
                We respect the confidentiality of your business ideas and
                sensitive information shared during consultations and workshops.
                We will not disclose this information to third parties without
                your explicit consent.
              </li>
            </ul>
            <h4>12. Payment:</h4>
            <ul>
              <li>
                Our consultation and workshop services are subject to the fees
                specified in the pricing agreement. Payment is due before the
                commencement of the consultation or workshop.
              </li>
            </ul>
            <h4>13. Cancellation and Refunds:</h4>
            <ul>
              <li>
                If you wish to cancel a scheduled consultation or workshop
                attendance, please provide notice at least 24 hours in advance.
                Refunds for cancelled services or workshops will be handled as
                per our refund policy.
              </li>
            </ul>
            <p>
              By engaging in our consultation and workshop services, you
              acknowledge that you have read, understood, and agreed to these
              terms and conditions. These terms and conditions may be subject to
              change, and any revisions will be communicated to you in advance.
            </p>
            <p>
              If you have any questions or concerns, please contact us before
              proceeding.
              <br /> Best regards,
              <br /> Emstell Kuwait Team
            </p>
          </article>
        </div>
      </div>
    </>
  );
}
